import { render, staticRenderFns } from "./MioClassroomAttainment.vue?vue&type=template&id=6f020364&"
import script from "./MioClassroomAttainment.vue?vue&type=script&lang=js&"
export * from "./MioClassroomAttainment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports